import { useNavigate } from 'react-router-dom';
import './Footer.css';

interface FooterProps { onBooking: () => void; }

export default function Footer({ onBooking }: FooterProps) {
  const navigate = useNavigate();
  const socialLinks = [
    { icon: 'ri-instagram-line', href: 'https://www.instagram.com/barberstudiol?igsh=MWpuMDMwMjR3Zmd3Yg==', label: 'Instagram' },
    { icon: 'ri-tiktok-line', href: 'https://www.tiktok.com/@barberstudio.l?_r=1&_t=ZS-95adJfnO26R', label: 'TikTok' },
  ];
  const quickLinks = [
    { label: 'Servicios', href: '#servicios' },
    { label: 'Nosotros', href: '#nosotros' },
    { label: 'El Barbero', href: '#barbero' },
    { label: 'Galería', href: '#galeria' },
    { label: 'Contacto', href: '#contacto' },
  ];
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer relative">
      <div className="footer-top-line" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-14">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center">
                <img src="https://storage.readdy-site.link/project_files/0d0d1fd6-befb-4f18-9f8b-efee19c55c96/fe9d8cd5-f344-4aec-86a2-924460c8dc34_LOGO-sin-letra.png?v=e571b3f4ddc76f76526cd8e946a6178b" alt="Barber Studio Luisfer" className="w-full h-full object-contain" />
              </div>
              <span className="footer-logo-text text-white font-semibold text-base tracking-widest uppercase">
                Barber Studio <span className="footer-logo-accent">Luisfer</span>
              </span>
            </div>
            <p className="footer-tagline max-w-xs mb-6">
              &ldquo;Donde cada corte es una obra maestra y cada cliente una historia que contar.&rdquo;
            </p>
            <div className="flex gap-3">
              {socialLinks.map((s) => (
                <a key={s.label} href={s.href} aria-label={s.label} className="footer-social-link cursor-pointer">
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>
          <div>
            <p className="footer-column-title">Navegación</p>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} onClick={(e) => { e.preventDefault(); scrollTo(link.href); }} className="footer-link cursor-pointer">
                    <span className="footer-link-arrow">›</span>{link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="footer-column-title">Contacto</p>
            <ul className="space-y-3 mb-6">
              <li className="footer-contact-item">
                <i className="ri-map-pin-line footer-contact-icon" />Calle 27b # 11-47, Barranquilla
              </li>
              <li>
                <a href="tel:+573000000000" className="footer-contact-link">
                  <i className="ri-phone-line footer-contact-icon" />+57 300 000 0000
                </a>
              </li>
              <li>
                <a href="mailto:info@barberstudioluisfer.com" className="footer-contact-link break-all">
                  <i className="ri-mail-line footer-contact-icon flex-shrink-0" />info@barberstudioluisfer.com
                </a>
              </li>
            </ul>
            <p className="footer-hours">Lun – Sáb: 8:30 – 12:00<br />1:30 PM – 6:00 PM</p>
            <button onClick={() => navigate('/reservar')} className="footer-cta mt-5 cursor-pointer">
              Reservar
            </button>
          </div>
        </div>
        <div className="footer-divider" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="footer-copyright">© 2026 Barber Studio Luisfer. Todos los derechos reservados.</p>
          <div className="flex gap-6">
            {['Privacidad', 'Términos', 'Cookies'].map((item) => (
              <a key={item} href="#" className="footer-legal-link">{item}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}